import moment from 'moment';

export const PROVIDER_NOT_FOUND_TEXT = 'Провайдер не найден';

export const formatPolicyProviders = (providerIds, row = {}) => {
  const providers = Array.isArray(row.providers) ? row.providers : [];
  if (providers.length) {
    return providers.map(provider => provider?.name || PROVIDER_NOT_FOUND_TEXT).join(', ');
  }

  const providerNames = Array.isArray(row.provider_names) ? row.provider_names.filter(Boolean) : [];
  if (providerNames.length) {
    return providerNames.join(', ');
  }

  if (Array.isArray(providerIds) && providerIds.length) {
    return providerIds.map(() => PROVIDER_NOT_FOUND_TEXT).join(', ');
  }

  return 'Все';
};

export const policiesColumns = [
  {
    dataField: 'name',
    text: 'policies.name',
    disableSort: true,
  },
  {
    dataField: 'description',
    text: 'policies.description',
    disableSort: true,
  },
  {
    dataField: 'provider_ids',
    text: 'policies.provider_ids',
    disableSort: true,
    formatter: formatPolicyProviders,
  },
  {
    dataField: 'currency',
    text: 'policies.currency',
    disableSort: true,
  },
  {
    dataField: 'start_date',
    text: 'policies.start_date',
    disableSort: true,
    formatter: t => (t ? moment(t).format('YYYY-MM-DD HH:mm:ss') : ''),
  },
  {
    dataField: 'end_date',
    text: 'policies.end_date',
    disableSort: true,
    formatter: t => (t ? moment(t).format('YYYY-MM-DD HH:mm:ss') : ''),
  },
  {
    dataField: 'published_date',
    text: 'policies.published_date',
    disableSort: true,
    formatter: t => (t ? moment(t).format('YYYY-MM-DD') : ''),
  },
  {
    dataField: 'prev_policies',
    text: 'policies.prev_policies',
    disableSort: true,
    formatter: t => (t && Array.isArray(t) ? t.join(', ') : ''),
  },
  {
    dataField: 'rules',
    text: 'policies.rules',
    disableSort: true,
    formatter: t => (t && Array.isArray(t) ? t.map(r => r.name).join(', ') : 'Все'),
  },
];

export const policiesAdditionalColumns = [];
